import styled from 'styled-components';
import Link from 'ggApp/shared/containers/FrontshopLink';
import { Hr } from '../Common';

export const Container = styled.footer`
    margin: 40px 0;
`;

export const Badge = styled.div`
    width: 36px;
    height: 24px;
    box-sizing: border-box;
    border-radius: 4px;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    align-items: center;
    :last-child {
        width: 97px;
    }
`;

export const Badges = styled.div`
    display: flex;
    align-items: center;
    padding: 0 16px;

    ${(props) => props.theme.superQuery.all.and.maxWidth.tabletMax.css`
        padding: 0;
        margin-bottom: 16px;
    `};

    ${Badge} + ${Badge} {
        margin-left: 16px;

        ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
            margin-left: 10px;
        `};

        ${({ theme }) => theme.superQuery.all.and.maxWidth.of('320px').css`
            margin-left: 5px;
        `};
    }
`;

export const Copyright = styled.div`
    display: inline-block;
    margin: 0 90px 0 0;
    line-height: 1.6875;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin: 0 8px;
    `}
`;

export const StyledLink = styled(Link)`
    display: inline-block;
    margin: 0 10px;
    color: #333;
    line-height: 1.6875;

    &:hover {
        color: #333;
        text-decoration: underline;
    }
`;

export const BottomContainer = styled.div`
    display: flex;
    padding: 0 16px;

    ${props => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 0;

        ${StyledLink} {
            margin: 0 8px;
        }
    `}
`;

export const Devider = styled(Hr)`
    ${props => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        display: none;
    `}
`;
